<footer id="footer">
  <div class="footer__container">
    @if (
      utilityService.country != "de" && !pageConfigService.getIsStorybrand()
    ) {
      <ul class="footer__list">
        <li>
          <div class="footer__list--title">
            {{ "texts.Footer_title_info" | translate }}
          </div>
        </li>
        @if (!authService.isTeacher() || !authService.isSignedIn()) {
          <li>
            <a (click)="searchService.openOrNavigateToSearch()">{{
              "texts.Misc_tutor_search" | translate
            }}</a>
          </li>
        }
        <li>
          <a
            href="https://media.bijlesaanhuis.nl/bijles/Privacyverklaring_Bijles_Aan_Huis_.pdf"
            target="_blank"
            rel="noopener"
            >{{ "texts.Footer_privacy" | translate }}</a
          >
        </li>
        <li>
          <a [routerLink]="['/Misc_terms'] | localize">{{
            "texts.Footer_terms" | translate
          }}</a>
        </li>
        @if (authService.isStudent()) {
          <li>
            <a [routerLink]="['/Footer_info_prices'] | localize">{{
              "texts.Footer_info_prices" | translate
            }}</a>
          </li>
        }
        <li>
          <a [routerLink]="['/Misc_contact'] | localize">{{
            "texts.Misc_contact" | translate
          }}</a>
        </li>
      </ul>
      <ul class="footer__list">
        <li>
          <div class="footer__list--title">
            {{ "texts.Footer_title_helpful" | translate }}
          </div>
        </li>
        <li>
          <a [routerLink]="['/Footer_info_blog'] | localize">{{
            "texts.Footer_info_blog" | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="['/Misc_learning_material'] | localize">{{
            "texts.Footer_learning_material" | translate
          }}</a>
        </li>
        @if (!authService.isStudent()) {
          <li>
            <a [routerLink]="['/Misc_become_tutor'] | localize">{{
              "texts.Footer_info_become_a_tutor" | translate
            }}</a>
          </li>
        }
        <li>
          <a (click)="openCookieSetting()">{{
            "texts.cookie_settings" | translate
          }}</a>
        </li>
      </ul>
    } @else {
      <ul class="footer__list">
        <li>
          <div class="footer__list--title">
            {{ "texts.Footer_title_about" | translate }}
          </div>
        </li>
        <li>
          <a [routerLink]="['/Misc_about_us'] | localize">{{
            "texts.Footer_info_find_team" | translate
          }}</a>
        </li>
        <li>
          <a
            href="https://media.lernigo.de/de/ALLGEMEINE_GESCHA%CC%88FTSBEDINGUNGEN_LERNIGO.pdf"
            target="_blank"
            rel="noopener"
            >{{ "texts.Footer_terms" | translate }}</a
          >
        </li>
        <li>
          <a
            href="https://media.lernigo.de/de/Lernigo_Datenschutzerkla%CC%88rung.pdf"
            target="_blank"
            rel="noopener"
            >{{ "texts.Footer_privacy" | translate }}</a
          >
        </li>
        @if (utilityService.country == "de") {
          <li>
            <a [routerLink]="['/Footer_company_details'] | localize">{{
              "texts.Footer_company_details" | translate
            }}</a>
          </li>
        }
      </ul>
      <ul class="footer__list">
        <li>
          <div class="footer__list--title">
            {{ "texts.Footer_title_more" | translate }}
          </div>
        </li>
        <li>
          <a [routerLink]="['/Misc_tutor_search'] | localize">{{
            "texts.Misc_tutor_search" | translate
          }}</a>
        </li>
        <li>
          <a (click)="openCookieSetting()">{{
            "texts.cookie_settings" | translate
          }}</a>
        </li>
      </ul>
      <ul class="footer__list">
        <li>
          <div class="footer__list--title">
            {{ "texts.Footer_title_support" | translate }}
          </div>
        </li>
        <li>
          <a [routerLink]="['/Misc_contact'] | localize">{{
            "texts.Misc_contact" | translate
          }}</a>
        </li>
        @if (!authService.isStudent()) {
          <li>
            <a [routerLink]="['/Misc_become_tutor'] | localize">{{
              "texts.Footer_info_become_a_tutor" | translate
            }}</a>
          </li>
        }
        <li>
          <a [routerLink]="['/Navigation_faq'] | localize" role="link">{{
            "texts.NavigationSection_faq" | translate
          }}</a>
        </li>
        <li>
          <a
            [href]="
              'tel:' +
              (variableService.contactVariable$ | async)?.contactPhoneLinked
            "
            role="link"
          >
            <i class="fa fa-phone-alt"></i>
            {{
              (variableService.contactVariable$ | async)?.contactPhoneDisplayed
            }}
            <br />
            <span style="font-size: 12px">
              {{
                "texts.NavigationSection_phone_info_new"
                  | translate
                    : {
                        open: (variableService.contactVariable$ | async)
                          ?.contactTimeOpen,
                        close: (variableService.contactVariable$ | async)
                          ?.contactTimeClose,
                      }
              }}
            </span>
          </a>
        </li>
      </ul>
    }

    <div class="footer__list footer__list__team">
      <li class="footer__list__people-item--title">
        <div class="footer__list--title">
          {{ "texts.Footer_title_team" | translate }}
        </div>
        <a
          [routerLink]="['/Navigation_vacancies'] | localize"
          class="footer__list--title footer__list--link"
        >
          {{ "texts.NavigationSection_vacancies" | translate }}
        </a>
      </li>
    </div>
    @if (!utilityService.isDE && !pageConfigService.getIsStorybrand()) {
      <ul class="footer__list">
        <li>
          <div class="footer__list--title">
            {{ "texts.Footer_title_offer" | translate }}
          </div>
        </li>
        <li>
          <a [routerLink]="['/Footer_subject_maths'] | localize">{{
            "texts.Footer_subject_maths" | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="['/Nederlands_Landing_Page'] | localize">{{
            "texts.Footer_subject_dutch" | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="['/Navigation_primary_school'] | localize">{{
            "texts.Footer_subject_primary_school" | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="['/Misc_Homepage_Test_Version'] | localize">{{
            "texts.NavigationSection_support" | translate
          }}</a>
        </li>
        <li>
          <a (click)="searchService.openOrNavigateToSearch()">{{
            "texts.Footer_subject_at_location" | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="['/Misc_tutoring_online'] | localize">{{
            "texts.NavigationSection_tutoring_online" | translate
          }}</a>
        </li>
      </ul>
    }
  </div>
  <div class="footer__social-media">
    <a
      [href]="'ROUTES.Misc_social_media_facebook' | translate"
      title="Follow on Facebook"
      target="_blank"
      rel="noopener"
      ><i class="fab fa-facebook-square"></i
    ></a>
    <a
      [href]="'ROUTES.Misc_social_media_instagram' | translate"
      title="Follow on Instagram"
      target="_blank"
      rel="noopener"
      ><i class="fab fa-instagram"></i
    ></a>
    <a
      [href]="'ROUTES.Misc_social_media_linkedin' | translate"
      title="Follow on LinkedIn"
      target="_blank"
      rel="noopener"
      ><i class="fab fa-linkedin"></i
    ></a>
  </div>
  <div class="footer__copyright">
    <p>
      {{ "texts.Footer_copyright" | translate }}
    </p>
  </div>
  @if (utilityService.isPwaStandalone()) {
    <p class="version-number">V. {{ utilityService.appVersion }}</p>
  }
</footer>
